import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from './config';
import { store } from './store';
import Routes from './routing/Routes';

import './styles/global.scss';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
  });
}

//@ts-ignore
const root = createRoot(document.getElementById('root'));
const isLocalBuild = process.env.CI_ENV === 'local';

root.render(
  <Provider store={store}>
    {isLocalBuild ? (
      <StrictMode>
        <Routes />
      </StrictMode>
    ) : (
      <Routes />
    )}
  </Provider>,
);
